import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// const getBaseUrl = () => {
//   if (process.env.REACT_APP_NODE_ENV === 'development') {
//     return `http://${process.env.REACT_APP_LOCAL_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use localhost for development
//   } 
//   else if (process.env.REACT_APP_NODE_ENV === 'staging') {
//     return `http://${process.env.REACT_APP_STAGING_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use localhost for development
//   } 
//   else {
//     return `http://${process.env.REACT_APP_PRODUCTION_URL}:${process.env.REACT_APP_SERVER_PORT}`; // Use server IP for other environments
//   }
// }; 

// const BASE_URL = getBaseUrl();

//UAT Server Base URL
// const BASE_URL = 'http://3.111.185.105:3502';

//Production Server Base URL
const BASE_URL = 'https://workwiseserve.shardatech.org';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // const navigate = useNavigate(); // Move useNavigate inside the error handler
    // Handle error
    if (error.response) {
      // navigate('/error');
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.error('Response Error:', error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      // navigate('/error');
      console.error('Request Error:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      // navigate('/error');
      console.error('Error:', error.message);
    }
    return Promise.reject(error); // Pass the error to the caller
  }
);

export default axiosInstance;

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});
